module.exports = __webpack_public_path__ + "static/media/balance-scale.24862755.svg";